import React, { useState, useEffect, useMemo } from 'react';
import T from 'prop-types';
// utils
import { waitFor } from 'utils/misc';
import { removeNotificationLoaded } from 'store/actions/notifications';
import { useSelector, useDispatch } from 'react-redux';
// components
import Typography from 'components/Typography';
// styles
import classnames from 'classnames/bind';
import styles from './Notifications.module.scss';

const cx = classnames.bind(styles);

const SNACK_GAP = 20; // px
const ANIM_TIME = 200; // ms

const Snack = ({ data: { message, type, duration }, snackKey, dispatch, idx }) => {
  const [closing, setClosing] = useState(false);
  const offsetTop = useMemo(() => (72 + SNACK_GAP) * idx, [idx]);

  const handleRemoveSnack = () => dispatch(removeNotificationLoaded(snackKey));

  useEffect(() => {
    const to = setTimeout(async () => {
      setClosing(true);
      await waitFor(ANIM_TIME);
      handleRemoveSnack();
    }, duration - ANIM_TIME);

    return () => clearTimeout(to);
  }, []);

  return (
    <div className={cx('snack', `snack--${type}`, { closing })} style={{ top: offsetTop }} onClick={handleRemoveSnack}>
      <Typography>{message}</Typography>
    </div>
  );
};

const Notifications = () => {
  const { notifications = {} } = useSelector(({ notifications }) => notifications);

  const dispatch = useDispatch();

  return (
    <div className={cx('container')}>
      <div className={cx('wrapper')}>
        {Object.entries(notifications).map(([key, snack], idx) => (
          <div key={key}>
            <Snack data={snack} snackKey={key} dispatch={dispatch} idx={idx} />
          </div>
        ))}
      </div>
    </div>
  );
};

Snack.propTypes = {
  data: T.shape({ message: T.string.isRequired, type: T.string, duration: T.number }).isRequired,
  snackKey: T.string.isRequired,
  dispatch: T.func.isRequired,
  idx: T.number.isRequired,
};

export default Notifications;
